import YouTubeTitle from './YouTubeTitle';

export default YouTubeTitle;
